import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import CreditStatusBadge from './CreditStatusBadge';
import { formatCurrency } from '../../../utils/currency';

const CustomerMobileCard = ({ customer, onViewProfile, onEdit, onDelete, onSendStatement, onViewPayments }) => {

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="font-heading font-semibold text-base text-foreground mb-1">
            {customer?.customerName || customer?.companyName}
          </h3>
          <p className="font-body text-sm text-muted-foreground">
            {customer?.contactPerson}
          </p>
        </div>
        <CreditStatusBadge status={customer?.creditStatus} />
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Mail" size={14} className="text-muted-foreground" />
          <span className="font-body text-foreground">{customer?.email}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Phone" size={14} className="text-muted-foreground" />
          <span className="font-body text-foreground">{customer?.phone}</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4 p-3 bg-muted/30 rounded-lg">
        <div>
          <p className="font-body text-xs text-muted-foreground mb-1">Outstanding</p>
          <p className={`font-body font-semibold text-sm ${
            customer?.outstandingBalance > 0 ? 'text-warning' : 'text-success'
          }`}>
            {formatCurrency(customer?.outstandingBalance)}
          </p>
        </div>
        <div>
          <p className="font-body text-xs text-muted-foreground mb-1">Credit Limit</p>
          <p className="font-body font-semibold text-sm text-foreground">
            {formatCurrency(customer?.creditLimit)}
          </p>
        </div>
        <div>
          <p className="font-body text-xs text-muted-foreground mb-1">Payment Terms</p>
          <p className="font-body text-sm text-foreground">{customer?.paymentTerms}</p>
        </div>
        <div>
          <p className="font-body text-xs text-muted-foreground mb-1">Category</p>
          <p className="font-body text-sm text-foreground">{customer?.category}</p>
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onViewProfile(customer)}
          iconName="Eye"
          iconPosition="left"
          className="flex-1"
        >
          View Profile
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onViewPayments(customer)}
          iconName="CreditCard"
        />
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onEdit(customer)}
          iconName="Edit"
        />
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onSendStatement(customer)}
          iconName="Send"
        />
      </div>
    </div>
  );
};

export default CustomerMobileCard;